<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #actions>
        <el-button class="filter-item" type="primary" size="mini" icon="el-icon-plus" @click="openForm()">新增</el-button>
      </template>
      <template #filters>
        <el-input v-model="query.keyword" clearable size="small" placeholder="课程名称/编码" class="filter-item" style="width: 200px; margin-right: 10px;" @keyup.enter.native="loadList" />
        <el-select v-model="query.subjectId" clearable filterable size="small" placeholder="所属科目" class="filter-item" style="width: 140px; margin-right: 10px;">
          <el-option v-for="s in subjectOptions" :key="s.id" :label="s.subjectName" :value="s.id" />
        </el-select>
        <el-select v-model="query.classType" clearable size="small" placeholder="可售班型" class="filter-item" style="width: 130px; margin-right: 10px;">
          <el-option label="班课" value="group" /><el-option label="一对一" value="private" /><el-option label="班课+私教" value="both" />
        </el-select>
        <el-select v-model="query.status" clearable size="small" placeholder="状态" class="filter-item" style="width: 120px; margin-right: 10px;">
          <el-option label="上架" :value="1" /><el-option label="下架" :value="0" />
        </el-select>
      </template>
    </school-list-toolbar>
    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column label="图片" width="72" align="center">
        <template slot-scope="{ row }">
          <img v-if="firstImage(row)" :src="toFullUrl(firstImage(row))" style="width: 44px; height: 44px; object-fit: cover; border-radius: 4px;">
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="courseCode" label="课程编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="courseName" label="课程名称" min-width="140" show-overflow-tooltip />
      <el-table-column label="科目" min-width="100"><template slot-scope="{ row }">{{ subjectName(row.subjectId) }}</template></el-table-column>
      <el-table-column label="班型" width="100" align="center"><template slot-scope="{ row }">{{ classTypeLabel(row.classType) }}</template></el-table-column>
      <el-table-column prop="sortNo" label="排序" width="70" align="center" />
      <el-table-column prop="status" label="状态" width="80" align="center">
        <template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">{{ row.status === 1 ? '上架' : '下架' }}</el-tag></template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160" />
      <el-table-column label="操作" min-width="80" width="80" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }"><div class="admin-pc-table-actions"><el-button type="text" size="mini" @click="openForm(row)">编辑</el-button></div></template>
      </el-table-column>
    </el-table>
    <school-list-pagination :total="total" :page="query.page" :size="query.size" @page-change="onPageChange" @size-change="onSizeChange" />
    <el-dialog :title="form.id ? '编辑课程' : '新增课程'" :visible.sync="formVisible" width="560px" :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="90px" size="small" class="admin-pc-dialog-form">
        <el-form-item v-if="form.id" label="课程编码">
          <el-input v-model="form.courseCode" disabled />
        </el-form-item>
        <p v-else class="admin-pc-form-hint">课程编码将在保存后自动生成</p>
        <el-form-item label="课程名称" prop="courseName"><el-input v-model="form.courseName" maxlength="128" /></el-form-item>
        <el-form-item label="所属科目" prop="subjectId"><el-select v-model="form.subjectId" filterable placeholder="请选择科目" style="width: 100%;"><el-option v-for="s in subjectOptions" :key="s.id" :label="s.subjectName" :value="s.id" /></el-select></el-form-item>
        <el-form-item label="可售班型" prop="classType"><el-select v-model="form.classType" style="width: 100%;"><el-option label="班课" value="group" /><el-option label="一对一" value="private" /><el-option label="班课+私教" value="both" /></el-select></el-form-item>
        <el-form-item label="图片">
          <admin-multi-image-upload v-model="form.imageUrls" :limit="9" />
        </el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sortNo" :min="0" :max="9999" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="form.status"><el-radio :label="1">上架</el-radio><el-radio :label="0">下架</el-radio></el-radio-group></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"><el-button size="small" @click="formVisible = false">取消</el-button><el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button></div>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import AdminMultiImageUpload from '../../admin/components/AdminMultiImageUpload.vue'
import schoolListPageMixin from './mixins/school-list-page'
import { fetchSchoolCourses, saveSchoolCourse, updateSchoolCourse, fetchSchoolSubjectOptions } from '@/api/h5-admin-schools'
import './schools-admin.less'

const DEFAULT_QUERY = { keyword: '', subjectId: null, classType: null, status: null, page: 0, size: 20 }

function emptyForm() {
  return { id: null, courseCode: '', courseName: '', subjectId: null, classType: 'group', imageUrls: [], sortNo: 0, status: 1 }
}

export default {
  name: 'SchoolsCourse',
  components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination, AdminMultiImageUpload },
  mixins: [schoolListPageMixin],
  data() {
    return {
      loading: false, saving: false, list: [], total: 0, subjectOptions: [], query: { ...DEFAULT_QUERY }, formVisible: false,
      form: emptyForm(),
      formRules: {
        courseName: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        subjectId: [{ required: true, message: '请选择科目', trigger: 'change' }],
        classType: [{ required: true, message: '请选择班型', trigger: 'change' }]
      }
    }
  },
  created() { this.loadSubjectOptions(); this.loadList() },
  methods: {
    handleReset() { this.resetListQuery(DEFAULT_QUERY) },
    loadSubjectOptions() { fetchSchoolSubjectOptions().then(list => { this.subjectOptions = list || [] }) },
    subjectName(id) { const s = this.subjectOptions.find(x => x.id === id); return s ? s.subjectName : (id || '-') },
    classTypeLabel(v) { const map = { group: '班课', private: '一对一', both: '班课+私教' }; return map[v] || v || '-' },
    firstImage(row) { return (row.imageUrls && row.imageUrls[0]) || row.coverUrl || '' },
    toFullUrl(raw) {
      const v = String(raw == null ? '' : raw).trim()
      if (!v) return ''
      if (/^https?:\/\//i.test(v)) return v
      if (v.startsWith('/')) return (process.env.NODE_ENV === 'development' ? window.location.origin : 'https://wvxvb.cn') + v
      return 'https://wvxvb.cn/upload/' + v.replace(/^\/+/, '')
    },
    loadList() {
      this.loading = true
      const params = { ...this.query }
      if (!params.classType) delete params.classType
      fetchSchoolCourses(params).then(res => { this.list = (res && res.content) || []; this.total = (res && res.totalElements) || 0 }).finally(() => { this.loading = false })
    },
    openForm(row) {
      if (row) {
        this.form = {
          id: row.id, courseCode: row.courseCode, courseName: row.courseName, subjectId: row.subjectId,
          classType: row.classType || 'group', imageUrls: Array.isArray(row.imageUrls) ? [...row.imageUrls] : [],
          sortNo: row.sortNo || 0, status: row.status != null ? row.status : 1
        }
      } else { this.resetForm() }
      this.formVisible = true
    },
    resetForm() { this.form = emptyForm(); this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate()) },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.id ? updateSchoolCourse(this.form.id, this.form) : saveSchoolCourse(this.form)
        req.then(() => { this.$message.success('保存成功'); this.formVisible = false; this.loadList() }).finally(() => { this.saving = false })
      })
    }
  }
}
</script>
